import store from '../store/index'
export default {
  computed: {
    applyApi () { return store.state.page.url },
    toProjectApi () { return store.state.page.url + '#/wel/index' }
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js